module.exports = __webpack_public_path__ + "img/silver-medal.998343cd.svg";